// ─── Crachá virtual (QR Code dinâmico do DDS) ───────────────────

// Prefixo que diferencia o QR do crachá virtual da matrícula pura do crachá físico
export const VIRTUAL_BADGE_QR_PREFIX = 'SSMA-BADGE:'

export type BadgeScanMode = 'physical' | 'virtual'

export interface VirtualBadgeToken {
	qrValue: string
	verificationCode: string
	issuedAt: string
	expiresAt: string
	badge: string
	name: string
	jobRole: string | null
}

export interface ResolvedBadge {
	personId: string
	badge: string
	name: string
	jobRole: string | null
}
